import { RouteProps } from "react-router";
import { connect } from "react-redux";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as actions from "src/bepaid/store/model/Fetch/actions";
import Component from "./View";

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = {
  enterpriseOnboardingSubmit: actions.enterpriseOnboardingSubmit,
  removeForm: actions.removeForm
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps & { qs: { [param: string]: any } };

export default connect(mapStateToProps, mapDispatchToProps)(Component);
